module.exports = __webpack_public_path__ + "media/images/landing/in_the_news_bg-849603fada48119f8307186de42961a8.jpg";